import { useLocation } from 'react-router-dom';
import { NewPhaseFormSchema } from '../../contract-page-components/ContractContent/types/new-phase-form-schema';

export const useGetReviseCurrentContractPrerequisites = () => {
  const location = useLocation();
  const navigationState = location.state ?? null;
  const parsedNavigationState = NewPhaseFormSchema.safeParse(navigationState);

  return parsedNavigationState.data;
};
